import React from 'react';

class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'oc'
  }
  render() {
    const {
      prefixCls,
    } = this.props;

    return (
      <div className={`${prefixCls}`}>
        <div className={`${prefixCls}-con`}>
          <h2>一、初始化</h2>
          <p>1、点击 <a href="files/ecfile/ecology.zip" target="_blank">这里</a> 获取开发包</p>
          <p>2、获取应用编码，发起应用开发申请时可以获取，以下称为[code]，这个[code]将贯穿整个解耦过程</p>
          <p>3、获取应用开发授权码，在应用开发流程中</p>
          <br />
          <h2>二、项目结构规范</h2>
          <p>1、JSP/html/js/css等文件位置：</p>
          <p>ecology/cloudstore/app/[code]/...</p>
          <p>2、CLASS文件位置：</p>
          <p>ecology/classbean/com/cloudstore/app/[code]/...</p>
          <p>3、其它配置文件位置：</p>
          <p>ecology/cloudstore/app/[code]/config/...</p>
          <br />
          <h2>三、配置文件规范：</h2>
          <p>1、应用基础配置：</p>
          <p>ecology/cloudstore/app/[code]/config/appInfo.xml如下，此文件将由云商店中开发流程中自动生成，也可手动建立</p>
          <pre>
          <code className="xml">
            {
              '<?xml version="1.0" encoding="UTF-8"?>'
              +'\n<root>'
              +'\n\t<name>xxx应用</name>'
              +'\n\t<desc>xxx描述</desc>'
              +'\n\t<code>[code]</code>'
              +'\n\t<version>XXX</version>'
              +'\n\t<pages>'
              +'\n\t\t<page>'
              +'\n\t\t\t<key>1</key>'
              +'\n\t\t\t<name>菜单名</name>'
              +'\n\t\t\t<url>地址</url>'
              +'\n\t\t</page>'
              +'\n\t</pages>'
              +'\n\t<mobilepages>'
              +'\n\t\t<page>'
              +'\n\t\t\t<key>1</key>'
              +'\n\t\t\t<name>菜单名</name>'
              +'\n\t\t\t<url>地址</url>'
              +'\n\t\t</page>'
              +'\n\t</mobilepages>'
              +'\n</root>'
            }
          </code>
          </pre>
          <p>2、数据库脚本配置：</p>
          <p>ecology/cloudstore/app/[code]/config/sqlserver.xml如下，脚本必须为增量脚本，且必须以应用编码作为前缀，oracle.xml以此类推</p>
          <pre>
          <code className="xml">
            {
              '<?xml version="1.0" encoding="UTF-8"?>'
              +'\n<sql>'
              +'\n\t<statement key="1">'
              +'\n\tcreate table [code]_tablename1 ('
              +'\n\tid int identity(1,1) not null'
              +'\n\t)' 
              +'\n\t</statement>'
              +'\n\t<statement key="2">'
              +'\n\tcreate table [code]_tablename2 ('
              +'\n\tid int identity(1,1) not null'
              +'\n\t)' 
              +'\n\t</statement>'
              +'\n</sql>'
            }
          </code>
          </pre>
          <br />
          <h2>四、JSP/CLASS调用规范：</h2>
          <p>1、调用范例，每个jsp和类文件都执行此程序，并将其中的内容用于代码各位置</p>	
          <pre>
          <code className="java">			
            {
              '<%@ page import="com.cloudstore.api.obj.Auth"%>'
              +'\n<jsp:useBean id="uca" class="com.cloudstore.api.util.Util_CheckAuth" scope="page" />'
              +'\n<%'
              +'\n\tAuth a = uca.initCloudStore(request,response);'
              +'\n\t//用户ID：a.getUserId() 部门ID：a.getDepId() 公司ID：a.getComId() 应用编码：a.getCode()'
              +'\n%>'
            }
          </code>
          </pre>
          <br />
          <h2>总结</h2>
          <p>按照步骤一到四处理后，应用即解耦，排除了对EC标准产品的影响</p>
        </div>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/oc/DevDoc.js